import { useState, useEffect, useCallback } from 'react';

const DEBUG_STORAGE_KEY = 'wondermaps_debug_mode';

function getInitialDebugMode(): boolean {
  // Check URL param first
  if (typeof window !== 'undefined') {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('debug') === 'true') {
      return true;
    }

    // Check hostname
    const hostname = window.location.hostname;
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return true;
    }

    // Check sessionStorage
    const stored = sessionStorage.getItem(DEBUG_STORAGE_KEY);
    if (stored === 'true') {
      return true;
    }
  }

  return false;
}

export function useDebugMode() {
  const [isDebugMode, setIsDebugMode] = useState(getInitialDebugMode);

  useEffect(() => {
    sessionStorage.setItem(DEBUG_STORAGE_KEY, String(isDebugMode));
  }, [isDebugMode]);

  const setDebugMode = useCallback((value: boolean) => {
    setIsDebugMode(value);
  }, []);

  return { isDebugMode, setDebugMode };
}
